import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {AppConfig} from '../config/app.config';
import {AuthenticationService} from '@ngx-ivengi/authentication';

@Injectable()
export class FileService {

  constructor(
    @Inject(AppConfig) private appConfig,
    private authService: AuthenticationService,
    private http: HttpClient
  ) {}

  public getLinkById(id: string): string {
    return `${this.appConfig.apiUrl}/file/${id}?access_token=${this.authService.getAccessToken()}`;
  }


  public deleteById(id): Observable<any> {
    return this.http.delete(`${this.appConfig.apiUrl}/file/${id}`);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/file/file.service.ts